import type { ReactNode } from 'react'

import type { Status } from './tokens'
import './system.css'

export function Badge({
  status,
  tone = false,
  children,
}: {
  status?: Status | undefined
  tone?: boolean
  children: ReactNode
}) {
  const classes = ['badge']

  if (status) {
    classes.push(`badge--${status}`)
  } else if (tone) {
    classes.push('badge--tone')
  }

  return <span className={classes.join(' ')}>{children}</span>
}
